import ResizableScene from "../core/ResizableScene";
export default class LayoutUtils {
    public static alignGrid(
        scene: ResizableScene,
        objects: Phaser.GameObjects.GameObject[],
        alignIn: Phaser.GameObjects.GameObject,
        tileSize: {x: number; y: number} | number,
        columns: number,
        offsetX = 0,
        offsetY = 0
    ): void {
        let tileSizeX = 0;
        let tileSizeY = 0;
        if (typeof tileSize == "number") {
            tileSizeX = tileSize;
            tileSizeY = tileSize;
        }
        else {
            tileSizeX = tileSize.x;
            tileSizeY = tileSize.y;
        }

        const rows = Math.ceil(objects.length / columns);
        const buttonsWidth = tileSizeX * columns;
        const buttonsHeight = tileSizeY * rows;

        const leftOver = objects.length % columns;

        for (let i = 0; i < objects.length; i++) {
            const object = objects[i];
            const x = i % columns;
            const y = Math.floor(i / columns);
            let xPos = (x / columns) * buttonsWidth;
            const yPos = (y / rows) * buttonsHeight;

            const lastRow = y == Math.floor((objects.length - 1) / columns);
            if (lastRow && leftOver > 0) xPos += (columns - leftOver) * (tileSizeX / 2);

            scene.alignIn.Center(
                object,
                alignIn,
                xPos - buttonsWidth / 2 + tileSizeX / 2 + offsetX,
                yPos - buttonsHeight / 2 + tileSizeY / 2 + offsetY
            );
        }
    }
    public static alignGridWidthHeight(
        scene: ResizableScene,
        objects: Phaser.GameObjects.GameObject[],
        alignIn: Phaser.GameObjects.GameObject,
        tileWidth: number,
        tileHeight: number,
        columns: number,
        offsetX = 0,
        offsetY = 0
    ): void {
        const rows = Math.ceil(objects.length / columns);
        const buttonsWidth = tileWidth * columns;
        const buttonsHeight = tileHeight * rows;

        const leftOver = objects.length % columns;

        for (let i = 0; i < objects.length; i++) {
            const object = objects[i];
            const x = i % columns;
            const y = Math.floor(i / columns);
            let xPos = (x / columns) * buttonsWidth;
            const yPos = (y / rows) * buttonsHeight;

            const lastRow = y == Math.floor((objects.length - 1) / columns);
            if (lastRow && leftOver > 0) xPos += (columns - leftOver) * (tileWidth / 2);

            scene.alignIn.Center(
                object,
                alignIn,
                xPos - buttonsWidth / 2 + tileWidth / 2 + offsetX,
                yPos - buttonsHeight / 2 + tileHeight / 2 + offsetY
            );
        }
    }
    public static scaleToMaxWidth(obj: Phaser.GameObjects.Text, maxWidth: number) {
        if (obj.width > maxWidth) obj.scale = maxWidth / obj.width;
    }

    public static alignHorizontally(scene:ResizableScene, objects:Phaser.GameObjects.GameObject[], alignIn:Phaser.GameObjects.GameObject, padding:number, alignmentOffset?:Phaser.Math.Vector2)
    {
        if(!alignmentOffset) alignmentOffset = new Phaser.Math.Vector2(0, 0);
        let totalWidth = 0;
        let startingX = 0;
        for (let i = 0; i < objects.length; i++) {
            const object = objects[i];
            if(object instanceof Phaser.GameObjects.Text || object instanceof Phaser.GameObjects.Sprite || object instanceof Phaser.GameObjects.Image)
            {
                if(i==0)
                {
                    scene.alignIn.Center(object, alignIn, alignmentOffset.x, alignmentOffset.y);
                    object.x += object.width*0.5;
                    startingX = object.x - object.width * object.originX;
                }
                else
                {
                    scene.alignTo.RightCenter(object, objects[i-1], padding, 0);
                    totalWidth = object.x + object.width*(1-object.originX) - startingX;
                }
            }
        }
       
        for (let i = 0; i < objects.length; i++) {
            const object = objects[i];
            if(object instanceof Phaser.GameObjects.Text || object instanceof Phaser.GameObjects.Sprite || object instanceof Phaser.GameObjects.Image)
            {
                object.x -= totalWidth/2;
            }
        }
    }
}
